import {React} from '@api'
import {useStores} from '@design-board'
import {PdfReportTemplate, SwatchesView, AssortmentDetails, RestorationHardwareStyle, PDFHeroCardStore, RHStylesContext, RHStyles, DEBUG_PDF, AssortmentImageView} from '@modules/pdf'
import ReactPDF, {Page, View, Text} from '@react-pdf/renderer'

export const assortmentBoardTemplate: PdfReportTemplate = {
  label: '',
  defaults: {
    sections: {
      cover: false,
      specGlossary: true,
      products: true
    },
    //sections: ['specGlossary', 'products'],
    watermark: false,
    document: [
      {
        size: 'A4',
        pageHeight: 515,
        orientation: 'landscape'
      }
    ],
    header: {
    }
  },
  renderReportTemplate: (props) => <AssortmentBoardTemplate {...props}/>
}

export interface IAssortmentBoardTemplate {
  data?: Array<PDFHeroCardStore>
  download?: boolean
}

export const AssortmentBoardTemplate = (props: IAssortmentBoardTemplate) => {
  const stores = useStores(),
    rhStore = new RHStyles(stores, props),
    {RootView, HeaderView, Title, Images} = RestorationHardwareStyle(rhStore),
    {data: assortmentStores} = props

  if (!Array.isArray(assortmentStores)) { return null }

  return <RHStylesContext.Provider value={rhStore}>
    {assortmentStores.filter(_.identity).map(({cardStore, cardsToRender, swatches}) => (
      <Page key={cardStore.id} size={rhStore.pageSize} orientation={'portrait'}>
        <RootView>
          <HeaderView>
            <Title>{cardStore.title}</Title>
            <AssortmentDetails attributes={cardStore.attributes} profileImageUrl={cardStore.headerImageUrl}/>
          </HeaderView>
          {cardsToRender.length > 0 &&
		   <Images>
             {cardsToRender.map((card, index) => (
               <AssortmentImageView fullWidth={index === 0}
                                    index={index}
                                    store={card}
                                    key={card.id}
                                    combine={card.assortmentHeroCardStore.data?.combined?.length > 0}/>)
             )}
			   <SwatchesView data={swatches}/>
		   </Images>
          }
        </RootView>
      </Page>
    ))}
  </RHStylesContext.Provider>
}




// WEBPACK FOOTER //
// ./src/modules/pdf/templates/restoration-hardware/AssortmentBoardTemplate.tsx